module.exports = __webpack_public_path__ + "assets/img/37_385_big.79c9fc43.jpg";